import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import type { IncidentStatus } from "../../../types";
import { keys } from "./keys";

type UpdateIncidentStatusParams = {
  incidentId: string;
  subjectId: string;
  status: IncidentStatus;
};


async function updateIncidentStatus(params: UpdateIncidentStatusParams) {
  const { data, error } = await apiClient
    .from('incidents')
    .update({ status: params.status })
    .eq('id', params.incidentId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function useUpdateIncidentStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateIncidentStatusParams) => updateIncidentStatus(params),
    onSuccess: (_data, variables) => {
      const message = variables.status === 'resolved'
        ? "Incident marqué comme terminé."
        : "Incident marqué comme en cours.";
      enqueueSnackbar(message, "success");

      queryClient.invalidateQueries({ queryKey: keys.subTopic(variables.subjectId) });
      queryClient.invalidateQueries({ queryKey: keys.subTopicIncidents(variables.subjectId) });
      queryClient.invalidateQueries({ queryKey: [...keys.all, 'activityTimeline'] });
    },
    onError: () => {
      enqueueSnackbar("Une erreur est survenue lors de la mise à jour de l'incident.", "error");
    },
  });
}
